import { useState } from "react";

export const useLoggedUser = (): any => {
  const userStorage = localStorage.getItem("user") || null;
  const [loggedUser, setLoggedUser] = useState<any>(
    userStorage ? JSON.parse(userStorage) : null
  );

  return {
    loggedUser,
  };
};
